import { render, staticRenderFns } from "./UnitServiceOrderHistoryAside.vue?vue&type=template&id=7fca49b8&"
import script from "./UnitServiceOrderHistoryAside.vue?vue&type=script&lang=js&"
export * from "./UnitServiceOrderHistoryAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports